import React from "react";
import WarehouseImg from "../assets/images/new-dashboards/warehouse.png";
import ReceiptIcon from "../assets/icons/receipt.png";
import ShipIcon from "../assets/icons/ship.png";
import { ContactForm } from "../components/ContactForm";

export function LucidWarehouse() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="newModuleHeader">
        <div className="newBackground"></div>
        <h3 className="mainSubhead white">Alpaca Warehouse</h3>
        <p className="body-text white">
          This app supports and streamlines shipping, receiving and warehousing
          processes and integrates seamlessly with Alpaca suite web apps.
        </p>
        <img
          src={WarehouseImg}
          alt="Alpaca Warehouse Dashboard"
          className="module-img"
        />
      </section>

      <section className="module-info">
        <div>
          <p className="body-text left">
            Alpaca Warehouse is designed to eliminate human error in
            shipping/receiving documentation by automating document creation and
            data entry, and serving as a central storage location. This powerful
            app tracks raw materials from procurement through the manufacturing
            process, while capturing key data that identifies efficiencies. It
            also creates and automates necessary documentation throughout the
            process.
          </p>

          <p className="body-text left">
            Users can customize the app to include key data points relevant to
            their material and component movements, enabling the operator to
            create a certification. These certifications are then made available
            for quality control files, simplifying the process for internal
            quality teams.
          </p>
        </div>

        <div>
          <div className="container-img-text">
            <img src={ReceiptIcon} alt="Effortless Posting Icon" />
            <div>
              <h3 className="smallSubhead">Effortless Posting</h3>
            </div>
          </div>

          <div className="container-img-text">
            <img src={ShipIcon} alt="Smooth Shipping Icon" />
            <div>
              <h3 className="smallSubhead">Smooth Shipping</h3>
            </div>
          </div>
        </div>
      </section>

      <ContactForm />
    </>
  );
}
